import { stripTrailingSlash } from '../utils/stripTrailingSlash';

export const NODE_ENV = process.env.NODE_ENV;

export const PUBLIC_URL = stripTrailingSlash(process.env.PUBLIC_URL);
export const REACT_APP_API_URL = stripTrailingSlash(process.env.REACT_APP_API_URL);
export const REACT_APP_SERVER = stripTrailingSlash(process.env.REACT_APP_SERVER);
export const REACT_APP_SECURE = stripTrailingSlash(process.env.REACT_APP_SECURE);

export const REACT_APP_DOMINIO = stripTrailingSlash(process.env.REACT_APP_DOMINIO);
export const REACT_APP_DOMINIO_CONFIGURADO = stripTrailingSlash(
  process.env.REACT_APP_DOMINIO_CONFIGURADO
);
export const REACT_APP_APIFY_URL = stripTrailingSlash(process.env.REACT_APP_APIFY_URL);
export const REACT_APP_SECURE_EPAYCO_URL = stripTrailingSlash(
  process.env.REACT_APP_SECURE_EPAYCO_URL
);
export const REACT_APP_PANEL_APP_REST_URL = stripTrailingSlash(
  process.env.REACT_APP_PANEL_APP_REST_URL
);
export const REACT_APP_SCRIPT_CHECKOUT_ORIGIN = stripTrailingSlash(
  process.env.REACT_APP_SCRIPT_CHECKOUT_ORIGIN || ''
);

export const REACT_APP_SCRIPT_CHECKOUT = stripTrailingSlash(
  process.env.REACT_APP_SCRIPT_CHECKOUT || ''
);

export const REACT_APP_SCRIPT_CHECKOUT_PAGO = stripTrailingSlash(
  process.env.REACT_APP_SCRIPT_CHECKOUT_PAGO || ''
);

export const REACT_APP_SCRIPT_CHECKOUT_PAGO_V2 = stripTrailingSlash(
  process.env.REACT_APP_SCRIPT_CHECKOUT_PAGO_V2 || ''
);


export const REACT_APP_MULTIMEDIA_EPAYCO_ORIGIN = stripTrailingSlash(
  process.env.REACT_APP_MULTIMEDIA_EPAYCO_ORIGIN || ''
);
export const REACT_APP_MERCURE = stripTrailingSlash(process.env.REACT_APP_MERCURE);
export const REACT_APP_SUBSCRIPTION_URL = stripTrailingSlash(
  process.env.REACT_APP_SUBSCRIPTION_URL
);
export const REACT_APP_NEW_CHECKOUT_URL = stripTrailingSlash(
  process.env.REACT_APP_NEW_CHECKOUT_URL
);
export const REACT_APP_URL_MULTIMEDIA_EPAYCO = stripTrailingSlash(
  process.env.REACT_APP_URL_MULTIMEDIA_EPAYCO
);
export const REACT_APP_MULTIMEDIA_EPAYCO_S3_URL = stripTrailingSlash(
  process.env.REACT_APP_MULTIMEDIA_EPAYCO_S3_URL
);
export const REACT_APP_FRAME_CHECKOUT_URL = stripTrailingSlash(
  process.env.REACT_APP_FRAME_CHECKOUT_URL
);

export const REACT_APP_DEV = process.env.REACT_APP_DEV;
export const REACT_APP_DEV_UPDATE_FACTURA = process.env.REACT_APP_DEV_UPDATE_FACTURA;
export const REACT_APP_SERVER_RESPONSE = process.env.REACT_APP_SERVER_RESPONSE;
export const REACT_APP_PROJECT_ID_RECAUDO = process.env.REACT_APP_PROJECT_ID_RECAUDO;
export const REACT_APP_CHECKOUT_VERSION = process.env.REACT_APP_CHECKOUT_VERSION;
export const REACT_APP_INVOICES_MINUTES_ALIVE = process.env.REACT_APP_INVOICES_MINUTES_ALIVE;
export const REACT_APP_SCRIPT_CHECKOUT_PAGO_SRI = process.env.REACT_APP_SCRIPT_CHECKOUT_PAGO_SRI;
export const REACT_APP_SCRIPT_CHECKOUT_PAGO_V2_SRI =
  process.env.REACT_APP_SCRIPT_CHECKOUT_PAGO_V2_SRI;
export const REACT_APP_SCRIPT_CHECKOUT_SRI = process.env.REACT_APP_SCRIPT_CHECKOUT_SRI;
